function record(value) {
    return value !== null && typeof value === 'object' && !Array.isArray(value);
}
function text(value) {
    return typeof value === 'string' && value.trim() ? value : undefined;
}
/** Reject broken control/text events; unrelated relay events remain harmless. Never rewrite words. */
export function parseCaptionStreamEvent(raw) {
    if (typeof raw !== 'string')
        return undefined;
    let event;
    try {
        event = JSON.parse(raw);
    }
    catch {
        return undefined;
    }
    if (!record(event) || typeof event.type !== 'string')
        return undefined;
    const { type, data } = event;
    if (type === 'auth_success')
        return { type };
    if (!['caption_stream_started', 'caption_transcript', 'caption_stream_stopped',
        'caption_stream_error', 'error', 'auth_error'].includes(type))
        return { type: 'ignored' };
    if (!record(data))
        return undefined;
    const sessionId = text(data.sessionId);
    if (type === 'caption_stream_error' || type === 'error' || type === 'auth_error') {
        return { type, data: { code: text(data.code), message: text(data.message), sessionId } };
    }
    if (!sessionId)
        return undefined;
    if (type === 'caption_stream_started')
        return { type, data: { sessionId } };
    if (type === 'caption_stream_stopped')
        return { type, data: { sessionId, reason: text(data.reason) } };
    if (!text(data.transcript) || typeof data.transcript !== 'string' || typeof data.isFinal !== 'boolean')
        return undefined;
    const confidence = typeof data.confidence === 'number' && Number.isFinite(data.confidence)
        && data.confidence >= 0 && data.confidence <= 1 ? data.confidence : undefined;
    const timestamp = typeof data.timestamp === 'number' && Number.isFinite(data.timestamp)
        && data.timestamp >= 0 && data.timestamp <= 8.64e15 ? data.timestamp : undefined;
    return {
        type: 'caption_transcript',
        data: {
            captionTone: data.captionTone, confidence, isFinal: data.isFinal,
            language: text(data.language), sessionId, timestamp,
            track: typeof data.track === 'string' && ['mixed', 'hearing', 'deaf', 'interpreter'].includes(data.track)
                ? data.track : undefined,
            transcript: data.transcript
        }
    };
}
